import React, { useState } from "react";
import styled from "styled-components";
import SVG from "src/utils/SVG";

interface ISwitchProps {
  id: string;
  checked?: boolean;
  dataType?: string;
  readonly?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const Switch = (props: ISwitchProps) => {
  const { id, checked, dataType } = props;
  const [isChecked, setIsChecked] = useState(checked || false);
  const [checkedItems, setCheckedItems] = useState(new Set());

  const switchHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(!isChecked);
    switchItemsHandler(e.target.id, e.target.checked);
  };
  const switchItemsHandler = (id: string, isChecked: boolean) => {
    if (isChecked) {
      checkedItems.add(id);
      setCheckedItems(checkedItems);
    } else if (!isChecked && checkedItems.has(id)) {
      checkedItems.delete(id);
      setCheckedItems(checkedItems);
    }
    return checkedItems;
  };

  return (
    <SwitchSet>
      <label htmlFor={id}>
        {isChecked ? <SVG name="switchActive" width={51} height={25} viewBox="0 0 51 25" /> : <SVG name="switch" width={51} height={25} viewBox="0 0 51 25" />}
        <input
          type="checkbox"
          id={id}
          data-type={dataType}
          checked={isChecked}
          onChange={(e) => {
            switchHandler(e);
            if (props.onChange) props.onChange(e);
          }}
        />
      </label>
    </SwitchSet>
  );
};

const SwitchSet = styled.span`
  display: inline-block;
  > label {
    display: inline-block;
    input {
      overflow: hidden;
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      border: 0;
      margin: -1px;
      clip: rect(0 0 0 0);
      appearance: none;
    }
  }
`;

export default Switch;
